import {
	Box,
	Stack,
	TableCell,
	TableHead,
	TableRow,
	tableCellClasses,
} from '@mui/material'
import FilterIcon from 'assets/FilterIcon'
import { FC, ReactNode } from 'react'
import { COLORS } from 'styles/colors'
import { TypographySecondary } from 'ui/typography/TypographySecondary'
import { CattlesSortOrderings } from '../types/cattlesSortTypes'

interface CattlesTableHeadProps {
	sortOrder: CattlesSortOrderings | null
	onSortOrder: (order: CattlesSortOrderings) => void
	showGroupColumn: boolean
	showLactationColumn: boolean
	showIdentificationColumns: boolean
	showFatnessColumn: boolean
	showLimpnessColumn: boolean
	dataColumnWidth: string
}

interface SortableHeaderCellProps {
	sortKey: CattlesSortOrderings
	sortOrder: CattlesSortOrderings | null
	onSortOrder: (order: CattlesSortOrderings) => void
	width?: string
	paddingRight?: string
	children: ReactNode
}

const SortableHeaderCell: FC<SortableHeaderCellProps> = ({
	sortKey,
	sortOrder,
	onSortOrder,
	width,
	paddingRight,
	children,
}) => (
	<TableCell
		align='left'
		padding='none'
		width={width}
		sx={paddingRight ? { paddingRight } : undefined}
	>
		<Stack direction='row' alignItems='center' gap='4px'>
			{children}
			<FilterIcon
				onClick={() => onSortOrder(sortKey)}
				color={sortOrder === sortKey ? COLORS.main : undefined}
			/>
		</Stack>
	</TableCell>
)

export const CattlesTableHead: FC<CattlesTableHeadProps> = ({
	sortOrder,
	onSortOrder,
	showGroupColumn,
	showLactationColumn,
	showIdentificationColumns,
	showFatnessColumn,
	showLimpnessColumn,
	dataColumnWidth,
}) => (
	<TableHead
		sx={{
			[`& .${tableCellClasses.root}`]: {
				backgroundColor: '#fff',
			},
		}}
	>
		<TableRow sx={{ width: '100%', height: '50px' }}>
			<TableCell
				align='left'
				padding='none'
				width={dataColumnWidth}
				sx={{ paddingRight: '5px' }}
			>
				<Box display='flex' flexDirection='row' alignItems='center' gap='4px'>
					<TypographySecondary>
						Номер бирки
						<br /> Номер ошейника
					</TypographySecondary>
				</Box>
			</TableCell>
			{showGroupColumn && (
				<SortableHeaderCell
					sortKey={CattlesSortOrderings.BY_GROUP}
					sortOrder={sortOrder}
					onSortOrder={onSortOrder}
					width={dataColumnWidth}
				>
					<TypographySecondary>Группа</TypographySecondary>
				</SortableHeaderCell>
			)}
			{showLactationColumn && (
				<SortableHeaderCell
					sortKey={CattlesSortOrderings.BY_LACTATION}
					sortOrder={sortOrder}
					onSortOrder={onSortOrder}
					width={dataColumnWidth}
				>
					<TypographySecondary>
						День
						<br />
						лактации
					</TypographySecondary>
				</SortableHeaderCell>
			)}
			{showIdentificationColumns && (
				<>
					<SortableHeaderCell
						sortKey={CattlesSortOrderings.BY_LAST_MILK_AMOUNT}
						sortOrder={sortOrder}
						onSortOrder={onSortOrder}
						width={dataColumnWidth}
						paddingRight='5px'
					>
						<TypographySecondary>Надой</TypographySecondary>
					</SortableHeaderCell>
					<SortableHeaderCell
						sortKey={CattlesSortOrderings.BY_LAST_MILKING_DT}
						sortOrder={sortOrder}
						onSortOrder={onSortOrder}
						width={dataColumnWidth}
						paddingRight='5px'
					>
						<TypographySecondary>
							Последнее
							<br />
							доение
						</TypographySecondary>
					</SortableHeaderCell>
				</>
			)}
			{showFatnessColumn && (
				<SortableHeaderCell
					sortKey={CattlesSortOrderings.BY_FATNESS}
					sortOrder={sortOrder}
					onSortOrder={onSortOrder}
					width={dataColumnWidth}
					paddingRight='5px'
				>
					<TypographySecondary>Упитанность</TypographySecondary>
				</SortableHeaderCell>
			)}
			{showLimpnessColumn && (
				<SortableHeaderCell
					sortKey={CattlesSortOrderings.BY_LIMPNESS}
					sortOrder={sortOrder}
					onSortOrder={onSortOrder}
					width={dataColumnWidth}
				>
					<TypographySecondary>Хромота</TypographySecondary>
				</SortableHeaderCell>
			)}
			<TableCell align='left' padding='none' width='6%'>
				<TypographySecondary>Действия</TypographySecondary>
			</TableCell>
		</TableRow>
	</TableHead>
)
